import { render, staticRenderFns } from "./all-reports-tab.vue?vue&type=template&id=161f77a8"
import script from "./all-reports-tab.vue?vue&type=script&lang=js"
export * from "./all-reports-tab.vue?vue&type=script&lang=js"
import style0 from "./all-reports-tab.vue?vue&type=style&index=0&id=161f77a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports